import { Link } from "react-router-dom";

import { NoTranslate } from "@/core/components/ui/no-translate";
import useTypedTranslation from "@/core/hooks/use-typed-translation";

export function AppFooter() {
  const { t } = useTypedTranslation();

  return (
    <footer>
      <div className="mx-auto flex size-full items-center justify-between gap-3 px-4 py-3 text-muted-foreground max-sm:flex-col sm:gap-6 sm:px-6">
        <p className="text-balance text-sm max-sm:text-center">
          {`©${new Date().getFullYear()}`}{" "}
          <NoTranslate as="span" className="font-medium text-foreground">
            {t("app.name")}
          </NoTranslate>{" "}
          — {t("layout.footer.tagline")}
        </p>
        <div className="flex items-center gap-5 max-sm:hidden">
          <Link
            to="/app/settings/profile"
            className="text-sm text-muted-foreground transition duration-300 hover:text-foreground"
          >
            {t("layout.footer.settings")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
